import IndustriesByCompany from '../../API/Services/IndustriesByCompany/IndustriesByCompany'
import { useCallback, useEffect, useState } from 'react'
import { Select } from '../Career/Select'
import IndustriesMapper from '../../Utils/IndustriesMapper'
import Loading from '../Loading/Loading'
import { FaBuilding } from 'react-icons/fa'
import { companiesIndustriesTranslate } from '../../i18n/translatedMessages'

export function CompaniesByIndustry() {
	const [loading, setLoading] = useState(false)
	const [currentPage, setCurrentPage] = useState(1)

	const [companies, setCompanies] = useState([])
	const [industryOptions, setIndustryOptions] = useState([])
	const [subIndustryOptions, setSubIndustryOptions] = useState([])
	const [allSubIndustryOptions, setAllSubIndustryOptions] = useState([])
	const [filters, setFilters] = useState({
		industryId: '',
		subIndustryId: '',
	})

	const totalPages = Math.ceil(companies.count / 50)

	const handlePageChange = pageNumber => {
		setCurrentPage(pageNumber)
	}

	const normalizeCompanies = companiesList => companiesList.map(company => (typeof company === 'string' ? { name: company } : company))

	const loadData = useCallback(async () => {
		try {
			setLoading(true)
			const { industryId, subIndustryId } = filters

			const respIndustries = await IndustriesByCompany.getAllIndustries()
			setIndustryOptions(respIndustries.industries.map(IndustriesMapper.toDomain))
			setAllSubIndustryOptions(respIndustries.subIndustries)

			if (industryId) {
				const selectedIndustry = respIndustries.subIndustries.find(industry => industry.industryId === parseInt(industryId))

				setSubIndustryOptions(selectedIndustry ? selectedIndustry.subindustries.map(IndustriesMapper.toDomain) : [])

				const respCompanies = await IndustriesByCompany.getCompanies(industryId, subIndustryId, currentPage)
				setCompanies({
					...respCompanies,
					companies: normalizeCompanies(respCompanies.companies),
				})
			}
		} catch (error) {
			console.error('Error loading data:', error)
		} finally {
			setLoading(false)
		}
	}, [filters, currentPage])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleFilter = e => {
		const selectedOption = e.target.value
		const { name } = e.target

		setFilters(prev => ({
			...prev,
			[name]: selectedOption || null,

			...(name === 'industryId' && { subIndustryId: '' }),
		}))

		setCurrentPage(1)
	}

	return (
		<div className='tw-pe-5'>
			{loading ? (
				<Loading />
			) : (
				<>
					<div className='tw-row tw-w-4/5'>
						<div className='tw-col'>
							<h3 className='tw-mb-4 tw-font-bold'>{companiesIndustriesTranslate.companiesIndustryTitle}</h3>
							<div className='tw-mb-4 tw-text-base'>{companiesIndustriesTranslate.companiesIndustryDesc}</div>
							<div className='tw-flex tw-space-x-5 tw-mb-4'>
								<div className='tw-w-1/5'>
									<Select placeholder='Industrias' list={industryOptions} onChange={handleFilter} name='industryId' value={filters.industryId} />
								</div>
								<div className='tw-w-1/5'>
									<Select
										placeholder='Subindustrias'
										list={subIndustryOptions}
										onChange={handleFilter}
										name='subIndustryId'
										value={filters.subIndustryId}
									/>
								</div>
							</div>
						</div>
					</div>

					<div className='tw-grid tw-grid-cols-2 tw-gap-4 tw-bg-gray-100 tw-p-4 tw-w-4/5 tw-rounded-lg'>
						{companies.companies?.length > 0 ? (
							companies.companies
								.filter(company => company.name)
								.map((company, index) => {
									const subIndustry = allSubIndustryOptions.subindustries?.find(sub => sub.id === company.subIndustry)

									return (
										<div key={index} className='tw-p-4 tw-border tw-rounded-lg tw-shadow-sm tw-bg-white'>
											<div className='tw-font-bold tw-text-lg'>{company.name}</div>
											{subIndustry && (
												<div className='tw-flex tw-space-x-2 tw-items-center tw-mt-2'>
													<FaBuilding size={12} />
													<div className='tw-text-gray-500'>{subIndustry.name}</div>
												</div>
											)}
										</div>
									)
								})
						) : (
							<div className='tw-col-span-2 tw-text-left tw-items-center tw-justify-center tw-p-6 tw-flex tw-h-[1000px]'>
								<div className='tw-w-[400px]'>
									<p className='tw-font-bold tw-text-lg'>{companiesIndustriesTranslate.companiesIndustryText1}</p>
									<p className='tw-mt-2 tw-mb-0 tw-text-purple-500'>{companiesIndustriesTranslate.companiesIndustryText2}</p>
									<p>{companiesIndustriesTranslate.companiesIndustryText3}</p>
								</div>
								<div>
									<img src={'https://assets.mydna.company/industry-subindustry-example.png'} alt='' className='tw-h-[150px]' />
								</div>
							</div>
						)}
					</div>

					{companies.count && (
						<div className='tw-flex tw-justify-center tw-items-center tw-mt-6 tw-space-x-4 tw-w-4/5'>
							<span>Total {companies.count} de Empresas</span>
							<div className='tw-flex'>
								<button
									onClick={() => handlePageChange(currentPage - 1)}
									disabled={currentPage === 1}
									className='tw-py-2 tw-px-3 tw-bg-white tw-border-purple-200 tw-text-purple-500 tw-text-sm tw-border'
								>
									{'<'}
								</button>

								<button
									onClick={() => handlePageChange(1)}
									className={`tw-py-2 tw-px-3 tw-text-sm tw-border-purple-200 tw-border ${
										currentPage === 1 ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-white tw-text-purple-500'
									}`}
								>
									1
								</button>

								{currentPage > 4 && <span className='tw-px-2'>...</span>}

								{Array.from({ length: 5 }, (_, i) => currentPage - 2 + i)
									.filter(page => page > 1 && page < totalPages)
									.map(page => (
										<button
											key={page}
											onClick={() => handlePageChange(page)}
											className={`tw-py-2 tw-px-3 tw-text-sm tw-border-purple-200 tw-border ${
												currentPage === page ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-white tw-text-purple-500'
											}`}
										>
											{page}
										</button>
									))}

								{currentPage < totalPages - 3 && <span className='tw-px-2'>...</span>}

								<button
									onClick={() => handlePageChange(totalPages)}
									className={`tw-py-2 tw-px-3 tw-text-sm tw-border-purple-200 tw-border ${
										currentPage === totalPages ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-white tw-text-purple-500'
									}`}
								>
									{totalPages}
								</button>

								<button
									onClick={() => handlePageChange(currentPage + 1)}
									disabled={currentPage === totalPages}
									className='tw-py-2 tw-px-3 tw-border tw-border-purple-200 tw-bg-white tw-text-purple-500 tw-text-sm'
								>
									{'>'}
								</button>
							</div>
						</div>
					)}
				</>
			)}
		</div>
	)
}
